<template>
  <div class="dashboard-search">
    <div class="dashboard-search__section">
      <TextField
        v-model="search"
        prepend-inner-icon="fas fa-search"
        :loading="isSearchBoxLoading"
        :label="textLabel"
        @input="$emit('dashboard-search', search)"
      />
      <div class="dashboard-search__section__subtitle mt-2 ml-2">{{ description }}</div>
    </div>
  </div>
</template>
<script>
import TextField from "@/components/TextField";
export default {
  name: "DashboardSearch",
  components: {
    TextField
  },
  props: {
    textLabel: {
      required: true,
      type: String
    },
    description: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      search: "",
      isSearchBoxLoading: false
    };
  }
};
</script>
<style lang="scss">
@import "../../../styles/settings/index";

.dashboard-search {
  &__section {
    .v-input {
      border-radius: 12px;
    }
    &__subtitle {
      font-size: 12px;
      font-weight: 500;
      color: $secondary-text;
    }
  }
}
</style>
